import { themeColors } from '../../themeColors';
/**
 * @file   src\form\FormSumbissionSuccess.js
 * @brief  This file is responsible for buyerlisting create want ad success page
 * @date   May, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState } from "react";
import FireWorkImgTop from "../../images/party-popper.png";
import BuyerlistingHeader from "@/form/BuyerListingHeader";
import { useLocation } from "react-router-dom";
import { toTitleCase } from "../../helpers/common";
import FooterButton from "../../components/Common/v2/FooterButton";
import ConfirmationModal from "../../components/Common/v2/ConfirmationModal";
import { useNavigate } from "react-router-dom";

const FormSubmissionSuccess = (props) => {
  const location = useLocation();
  const state = location.state;
  const agentDetails = state && state.agentDetails ? state.agentDetails : null;
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handlePrimaryClick = () => {
    navigate(-1);
  };

  const handleSecondaryClick = () => {
    setShowModal(false);
  };

  return (
    <>
      <div className="outer-wrap position-relative mw-100 vh-100 pd_zero first-wantad-wrap">
        <div className="first-wantad-header first-wantad-header-mob pt-24">
          <div className="inner-width-wantad ">
            <BuyerlistingHeader agentDetails={agentDetails} />
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center first-wantad-content">
              <div className="">
                <div className="pyro pyro-left-top">
                  <div className="before"></div>
                  <div className="after"></div>
                </div>
                <img
                  className="mw-48"
                  src={FireWorkImgTop}
                  width={"48px"}
                  height={"48px"}
                />
                <h6 className="mt-4">
                  Great work! We’ve sent this over to{" "}
                  {toTitleCase(agentDetails?.FirstName)} for review.
                </h6>
              </div>

              <h2>You’re on the way to finding your perfect property!</h2>
              <h5>
                Your agent will be doing everything in their power to find you
                the home or property of your dreams, <br />
                and it starts here at the Buyer Listing Service.
              </h5>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 text-center first-wantad-content mt-4 mb-4">
              <h3>How it works</h3>
            </div>
            <div className="col-md-4">
              <div className="create-first-contentbox min-ht-container mb-24">
                <div className="create-first-icon mb-4">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.4 2.66666C15.1922 2.66666 14.9844 2.73416 14.8124 2.87003L5.81094 9.98064C4.66017 10.8892 4 12.2528 4 13.7207V25.8413C4 26.7168 4.7106 27.4286 5.58333 27.4286H11.9167C12.7894 27.4286 13.5 26.7168 13.5 25.8413V18.8571C13.5 18.6825 13.6419 18.5397 13.8167 18.5397H16.9833C17.1581 18.5397 17.3 18.6825 17.3 18.8571V22.1954L19.2 20.2907V18.8571C19.2 17.6317 18.2057 16.6349 16.9833 16.6349H13.8167C12.5943 16.6349 11.6 17.6317 11.6 18.8571V25.5238H5.9V13.7207C5.9 12.8395 6.29573 12.0222 6.98607 11.4774L15.4 4.8306L23.8139 11.4774C24.5043 12.0222 24.9 12.8395 24.9 13.7207V14.0952C25.5669 14.0952 26.2047 14.2167 26.8 14.4288V13.7207C26.8 12.2522 26.1398 10.8899 24.9891 9.98064L15.9876 2.87003C15.8153 2.73416 15.6078 2.66666 15.4 2.66666ZM24.9 15.3651C22.4515 15.3651 20.4667 17.3549 20.4667 19.8095C20.4667 20.1225 20.4992 20.4276 20.5607 20.7222L15.5855 25.7098C15.4665 25.8285 15.4 25.9905 15.4 26.1587V28.6984C15.4 29.0489 15.6831 29.3333 16.0333 29.3333H18.5667C18.9169 29.3333 19.2 29.0489 19.2 28.6984V27.4286H20.4667C20.8169 27.4286 21.1 27.1441 21.1 26.7936V25.5238H22.3667C22.7169 25.5238 23 25.2394 23 24.8889V23.8199C23.5763 24.0949 24.2192 24.254 24.9 24.254C27.3485 24.254 29.3333 22.2641 29.3333 19.8095C29.3333 17.3549 27.3485 15.3651 24.9 15.3651ZM25.5333 17.9048C26.2332 17.9048 26.8 18.473 26.8 19.1746C26.8 19.8762 26.2332 20.4444 25.5333 20.4444C24.8335 20.4444 24.2667 19.8762 24.2667 19.1746C24.2667 18.473 24.8335 17.9048 25.5333 17.9048Z"
                      fill={themeColors.accentf600}
                    />
                  </svg>
                </div>
                <h6 className="mb-2">
                  Your agent shares all of the specifics of your search
                </h6>
                <p>
                  The Buyer Listing Service is the place for your agent to list
                  and share your wants & needs with their professional network
                  so agents with homes that match can bring them to you.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="create-first-contentbox min-ht-container mb-24">
                <div className="create-first-icon mb-4">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M3.05018 3.66395C3.33148 3.38265 3.71301 3.22461 4.11084 3.22461H20.6108C21.0087 3.22461 21.3902 3.38264 21.6715 3.66395C21.9528 3.94525 22.1108 4.32679 22.1108 4.72461V19.7246C22.1108 19.9845 21.9762 20.2259 21.7551 20.3626C21.534 20.4993 21.2579 20.5117 21.0254 20.3954L18.3608 19.0631L15.6963 20.3954C15.4851 20.501 15.2366 20.501 15.0254 20.3954L12.3608 19.0631L9.69625 20.3954C9.4851 20.501 9.23658 20.501 9.02543 20.3954L6.36084 19.0631L3.69625 20.3954C3.46376 20.5117 3.18765 20.4993 2.96654 20.3626C2.74543 20.2259 2.61084 19.9845 2.61084 19.7246V4.72461C2.61084 4.32678 2.76888 3.94525 3.05018 3.66395ZM20.6108 4.72461L4.11084 4.72461L4.11084 18.5111L6.02543 17.5538C6.23658 17.4482 6.4851 17.4482 6.69625 17.5538L9.36084 18.8861L12.0254 17.5538C12.2366 17.4482 12.4851 17.4482 12.6962 17.5538L15.3608 18.8861L18.0254 17.5538C18.2366 17.4482 18.4851 17.4482 18.6963 17.5538L20.6108 18.5111V4.72461Z"
                      fill={themeColors.accentf600}
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M13.1108 9.97461C13.1108 9.5604 13.4466 9.22461 13.8608 9.22461H18.3608C18.7751 9.22461 19.1108 9.5604 19.1108 9.97461C19.1108 10.3888 18.7751 10.7246 18.3608 10.7246H13.8608C13.4466 10.7246 13.1108 10.3888 13.1108 9.97461Z"
                      fill={themeColors.accentf600}
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M13.1108 12.9746C13.1108 12.5604 13.4466 12.2246 13.8608 12.2246H18.3608C18.7751 12.2246 19.1108 12.5604 19.1108 12.9746C19.1108 13.3888 18.7751 13.7246 18.3608 13.7246H13.8608C13.4466 13.7246 13.1108 13.3888 13.1108 12.9746Z"
                      fill={themeColors.accentf600}
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5.61084 8.47461C5.61084 8.0604 5.94663 7.72461 6.36084 7.72461H10.8608C11.2751 7.72461 11.6108 8.0604 11.6108 8.47461V14.4746C11.6108 14.8888 11.2751 15.2246 10.8608 15.2246H6.36084C5.94663 15.2246 5.61084 14.8888 5.61084 14.4746V8.47461ZM7.11084 9.22461V13.7246H10.1108V9.22461H7.11084Z"
                      fill={themeColors.accentf600}
                    />
                  </svg>
                </div>
                <h6 className="mb-2">
                  The Buyer Listing Service gets to work for you and your agent
                </h6>
                <p>
                  Your criteria gets posted on the listing feed, where agents
                  will be automatically notified if what they have matches what
                  you’re looking for. To provide additional exposure Gitcha will
                  be marketing your agent’s want-listing, too!
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="create-first-contentbox min-ht-container mb-24">
                <div className="create-first-icon mb-4">
                  <svg
                    width="24"
                    height="23"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.9784 4.00512C18.3086 4.03613 17.6413 4.20817 17.0188 4.51944C17.0007 4.52845 16.9829 4.538 16.9654 4.54809L15.0748 5.64054C15.0548 5.6395 15.0349 5.63907 15.0149 5.63923H2.34823C2.21572 5.63736 2.08415 5.66184 1.96118 5.71126C1.83822 5.76067 1.72629 5.83403 1.63192 5.92707C1.53756 6.02012 1.46262 6.13099 1.41147 6.25325C1.36032 6.37551 1.33398 6.50671 1.33398 6.63923C1.33398 6.77176 1.36032 6.90296 1.41147 7.02522C1.46262 7.14748 1.53756 7.25835 1.63192 7.35139C1.72629 7.44444 1.83822 7.5178 1.96118 7.56721C2.08415 7.61663 2.21572 7.64111 2.34823 7.63923H10.8573L10.4224 7.82022C10.4009 7.82903 10.3796 7.83858 10.3586 7.84887C9.25041 8.40299 8.73914 9.5834 8.84953 10.6457C8.95992 11.7081 9.72045 12.7672 10.9394 13.0715C11.4145 13.1899 11.9423 13.259 12.5175 13.259C15.4332 13.259 18.2904 12.3505 19.136 12.0702C19.692 12.691 22.4343 15.7556 23.3508 16.6939C24.0145 17.373 24.0817 18.0361 23.9107 18.5077C23.7397 18.9794 23.3515 19.3437 22.5058 19.3463C22.2761 19.3469 22.0536 19.4267 21.8758 19.572C21.698 19.7174 21.5756 19.9195 21.5292 20.1444C21.2799 21.3503 20.8399 21.5215 20.3912 21.6392C19.9425 21.757 19.5097 21.6549 19.5097 21.6549C19.3639 21.615 19.2109 21.6088 19.0623 21.6366C18.9137 21.6644 18.7734 21.7256 18.6518 21.8154C18.5302 21.9053 18.4306 22.0215 18.3605 22.1554C18.2903 22.2893 18.2514 22.4374 18.2467 22.5885C18.2467 22.5885 18.2135 23.1048 17.9589 23.5468C17.7043 23.9888 17.4392 24.3614 16.2519 24.2317C15.9999 24.204 15.7468 24.273 15.5437 24.4248C15.3407 24.5766 15.2028 24.7998 15.1581 25.0494C15.022 25.8105 14.6082 26.1408 13.9876 26.2551C13.3669 26.3694 12.5242 26.1662 11.787 25.4374C10.8432 24.5046 7.40186 20.9951 5.84432 19.4049C5.1547 18.7006 4.21027 18.3059 3.22713 18.3059H2.34823C2.21572 18.304 2.08415 18.3285 1.96118 18.3779C1.83822 18.4273 1.72629 18.5007 1.63192 18.5937C1.53756 18.6868 1.46262 18.7977 1.41147 18.9199C1.36032 19.0422 1.33398 19.1734 1.33398 19.3059C1.33398 19.4384 1.36032 19.5696 1.41147 19.6919C1.46262 19.8141 1.53756 19.925 1.63192 20.0181C1.72629 20.1111 1.83822 20.1845 1.96118 20.2339C2.08415 20.2833 2.21572 20.3078 2.34823 20.3059H3.22713C3.67867 20.3059 4.10156 20.4835 4.41594 20.8046C5.9744 22.3957 9.38326 25.8734 10.3808 26.8593C11.531 27.9965 13.0141 28.4685 14.3495 28.2226C15.4323 28.0232 16.3806 27.268 16.8547 26.1913C17.9951 26.0962 18.8714 25.5724 19.4003 24.9478C19.4138 24.9485 19.4272 24.949 19.4407 24.9491C19.4407 24.9491 22.45 25.0016 24.1243 24.9491C25.289 24.913 26.4632 24.5177 27.4993 23.6093C27.9666 23.1998 28.5289 22.9713 29.1008 22.9713H29.6816C29.8141 22.9731 29.9456 22.9487 30.0686 22.8992C30.1916 22.8498 30.3035 22.7765 30.3979 22.6834C30.4922 22.5904 30.5672 22.4795 30.6183 22.3573C30.6695 22.235 30.6958 22.1038 30.6958 21.9713C30.6958 21.8387 30.6695 21.7075 30.6183 21.5853C30.5672 21.463 30.4922 21.3521 30.3979 21.2591C30.3035 21.1661 30.1916 21.0927 30.0686 21.0433C29.9456 20.9939 29.8141 20.9694 29.6816 20.9713H29.1008C27.9981 20.9713 26.9742 21.4109 26.1816 22.1054C25.4536 22.7437 24.8757 22.9252 24.0631 22.9504H24.0618C23.5158 22.9676 22.7554 22.9641 22.0396 22.9635C22.5498 22.5429 23.0073 21.9316 23.2896 21.1145C24.445 20.8504 25.4242 20.2016 25.7909 19.19C26.2436 17.9415 25.8915 16.4324 24.7805 15.2955C23.9387 14.4336 20.2011 10.2694 20.2011 10.2694C20.07 10.1231 19.8987 10.0187 19.7086 9.96912C19.5184 9.91957 19.3179 9.92711 19.1321 9.9908C19.1321 9.9908 15.3236 11.259 12.5175 11.259C12.102 11.259 11.7406 11.2104 11.4237 11.1314C11.0247 11.0318 10.8739 10.7734 10.8391 10.4387C10.8045 10.106 10.914 9.81219 11.2493 9.64184L14.3795 8.34236C14.4198 8.32541 14.4589 8.30584 14.4967 8.28377L17.9185 6.3059C18.6746 5.92953 19.478 5.90119 20.2063 6.19262L24.7128 7.9947C25.225 8.20044 25.7718 8.30444 26.3222 8.3046L29.6816 8.3059C29.8141 8.30778 29.9456 8.28329 30.0686 8.23388C30.1916 8.18447 30.3035 8.11111 30.3979 8.01806C30.4922 7.92502 30.5672 7.81414 30.6183 7.69189C30.6695 7.56963 30.6958 7.43843 30.6958 7.3059C30.6958 7.17338 30.6695 7.04217 30.6183 6.91992C30.5672 6.79766 30.4922 6.68679 30.3979 6.59374C30.3035 6.5007 30.1916 6.42734 30.0686 6.37792C29.9456 6.32851 29.8141 6.30403 29.6816 6.3059L26.3235 6.3046C26.0263 6.3046 25.733 6.24934 25.4589 6.13923L25.4563 6.13793L20.9498 4.33585C20.3201 4.08389 19.6482 3.97411 18.9784 4.00512Z"
                      fill={themeColors.accentf600}
                    />
                  </svg>
                </div>
                <h6 className="mb-2">
                  Agents representing sellers cater to you for once
                </h6>
                <p>
                  Your agent will field introductions of potential properties
                  that may fit what you’re looking for and will reach out when
                  they have something exciting to present to you!
                </p>
              </div>
            </div>
          </div>
        </div>
        <FooterButton
          isMobileView={false}
          buttonText="Fill it out again"
          onClick={() => setShowModal(true)}
        />

        <ConfirmationModal
          show={showModal}
          onHide={() => setShowModal(false)}
          isMobileView={false}
          heading="Are you sure you want
        to restart?"
          messageText=""
          primaryButtonText="Confirm"
          secondaryButtonText="No thanks"
          onPrimaryClick={handlePrimaryClick}
          onSecondaryClick={handleSecondaryClick}
        />
      </div>
    </>
  );
};

export default FormSubmissionSuccess;
